import { create } from 'zustand';
import type { UserProfile } from '../types/user';

interface OnboardingState {
  displayName: string;
  role: string;
  experience: string;
  industry: string;
  goalsText: string;
  supportNeed: string;
  recommendedCoach: string;
  selectedCoach: string;
  phoneNumber: string;
  maskedPhoneNumber: string;
  timezone: string;
  setDisplayName: (displayName: string) => void;
  setRole: (role: string) => void;
  setExperience: (experience: string) => void;
  setIndustry: (industry: string) => void;
  setGoalsText: (goalsText: string) => void;
  setSupportNeed: (supportNeed: string) => void;
  setRecommendedCoach: (coach: string | null) => void;
  setSelectedCoach: (coach: string | null) => void;
  setPhoneNumber: (phone: string) => void;
  setMaskedPhoneNumber: (phone: string) => void;
  setTimezone: (tz: string) => void;
  hydrateFromProfile: (profile: UserProfile) => void;
  reset: () => void;
}

export const useOnboardingStore = create<OnboardingState>((set) => ({
  displayName: '',
  role: '',
  experience: '',
  industry: '',
  goalsText: '',
  supportNeed: '',
  recommendedCoach: '',
  selectedCoach: '',
  phoneNumber: '',
  maskedPhoneNumber: '',
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',

  setDisplayName: (displayName) => set({ displayName }),
  setRole: (role) => set({ role }),
  setExperience: (experience) => set({ experience }),
  setIndustry: (industry) => set({ industry }),
  setGoalsText: (goalsText) => set({ goalsText }),
  setSupportNeed: (supportNeed) => set({ supportNeed }),
  setRecommendedCoach: (coach) => set({ recommendedCoach: coach ?? '' }),
  setSelectedCoach: (coach) => set({ selectedCoach: coach ?? '' }),
  setPhoneNumber: (phone) => set({ phoneNumber: phone }),
  setMaskedPhoneNumber: (phone) => set({ maskedPhoneNumber: phone }),
  setTimezone: (tz) => set({ timezone: tz }),
  hydrateFromProfile: (profile) =>
    set({
      role: profile.current_role ?? '',
      experience: profile.years_of_experience ?? '',
      industry: profile.industry ?? '',
      goalsText: profile.goal_statement ?? '',
      supportNeed: profile.support_need ?? '',
      recommendedCoach: profile.recommended_coach ?? '',
      selectedCoach: profile.preferred_coach ?? '',
      phoneNumber: profile.phone_number ?? '',
      maskedPhoneNumber: profile.masked_phone_number ?? '',
      timezone: profile.timezone ?? (Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'),
    }),
  reset: () =>
    set({
      displayName: '',
      role: '',
      experience: '',
      industry: '',
      goalsText: '',
      supportNeed: '',
      recommendedCoach: '',
      selectedCoach: '',
      phoneNumber: '',
      maskedPhoneNumber: '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
    }),
}));
